import ServiceTemplate from '@/components/template/service/ServiceTemplate';
import { Col, Form, FormItem, Input, Row, Title } from '@/components/atoms';
import TextArea from '@/components/atoms/input/TextArea';

const ServiceManageFormPage = () => {
  return (
    <ServiceTemplate>
      <Title>민원 신청 양식</Title>
      <Form layout="vertical">
        <Row>
          <Col span={12}>
            <FormItem label="회사명">
              <Input />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="대표명">
              <Input />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="담당자 이름">
              <Input />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="담당자 연락처">
              <Input />
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem label="회사주소">
              <Input />
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem label="민원 신청 제목">
              <Input />
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem label="민원 신청 내용">
              <TextArea />
            </FormItem>
          </Col>
        </Row>
      </Form>
    </ServiceTemplate>
  );
};

export default ServiceManageFormPage;
